import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";

import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
import { updateUser } from "../../actions/user";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ToastContainer, toast } from "react-toastify";

const EditAccount = (props) => {
  const [value, setValue] = useState({
    loading: true,
    user: [],
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    confirm_email: "",
    phone: 0,
    id: "",
  });

  useEffect(() => {
    var data = JSON.parse(localStorage.getItem("user"));
    if (data) {
      setValue({
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        confirm_email: data.email,
        phone: data.phone,
        id: data._id,
      });
    }
  }, []);

  const _submitHandler = async () => {
    const { email, firstName, lastName, phone, confirm_email, id } = value;
    console.log(props);
    console.log(props._auth.user);
    if (email === confirm_email) {
      setValue({ loading: true });
      const userId = value.id;
      const formData = {
        _id: userId,
        firstName,
        lastName,
        email,
        phone: phone ? phone : 0,
      };
      const res = await props.updateUser(formData);
      setValue({ loading: false });
      if (res.status === 200) {
        setValue({
          email: res.email,
          firstName: res.firstName,
          lastName: res.lastName,
          confirm_email: res.email,
          phone: res.phone,
        });
        toast(`Profile Has been Updated`, { containerId: "B" });
      } else {
        toast.error(`Something is went Wrong`, { containerId: "B" });
      }
    } else {
      toast.error(`${"Confirm Email is not Same"}`, { containerId: "B" });
    }
  };
  const handleChange = (e) => {
    e.target.id = e.target.value;
  };
  const { firstName, lastName, email, confirm_email, phone } = value;

  return (
    <Fragment>
      <ToastContainer
        enableMultiContainer
        containerId={"B"}
        position={toast.POSITION.TOP_RIGHT}
      />
      <div className="personal-info-wrapper wrapper-90 max-1600">
        <div className="container-fluid">
          <div className="row">
            {/* <AccountLeftSidebar /> */}
            <div className="col-md-12">
              <div className="bg-cream p-3">
                <div className="personal-info-heading">
                  <h3 className="p-info-heading-title">Personal Info</h3>
                  <span className="p-info-heading-hints">
                    To make updates, type your new info in the form field you
                    want to change and click the SAVE button.
                  </span>
                </div>

                <section className="personal-i-section">
                  <div className="pi-section-content">
                    <div className="pi-section-header">
                      <h2 className="pi-section-title">Name</h2>
                    </div>
                    <div className="pi-section-inputs">
                      <div className="pi-name-inp">
                        <label htmlFor="name" className="pi-text-field">
                          <input
                            type="text"
                            id="firstNameUpdate"
                            className="pi-input pi-fname"
                            name="firstName"
                            maxLength={32}
                            defaultValue={firstName && firstName}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          <span className="pi-placeholder">First Name</span>
                        </label>
                      </div>
                      <div className="pi-name-inp">
                        <label htmlFor="name" className="pi-text-field">
                          <input
                            type="text"
                            id="lastNameUpdate"
                            className="pi-input pi-lname"
                            name="lastName"
                            maxLength={32}
                            defaultValue={lastName && lastName}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          <span className="pi-placeholder">Last Name</span>
                        </label>
                      </div>
                      <div className="pi-name-inp">
                        <label htmlFor="phone" className="pi-text-field">
                          <input
                            type="number"
                            id="phone"
                            className="input-type-number pi-input pi-lname"
                            name="phone"
                            maxLength={32}
                            defaultValue={phone && phone}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          <span className="pi-placeholder">Phone</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="pi-section-content">
                    <div className="pi-section-header">
                      <h2 className="pi-section-title">Email</h2>
                      <span className="pi-c-email">
                        Current Email: {email && email}
                      </span>
                    </div>
                    <div className="pi-section-inputs">
                      <div className="pi-newemail-inp">
                        <label htmlFor="newemail" className="pi-text-field">
                          <input
                            type="text"
                            id="pi-newemail"
                            className="pi-input pi-newemail"
                            name="email"
                            defaultValue={email && email}
                            maxLength={96}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          <span className="pi-placeholder">New Email</span>
                        </label>
                      </div>
                      <div className="pi-verify-email-inp">
                        <label htmlFor="verify-email" className="pi-text-field">
                          <input
                            type="text"
                            id="pi-verify-email"
                            className="pi-input pi-verify-email"
                            name="confirm_email"
                            maxLength={96}
                            defaultValue={confirm_email && confirm_email}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          <span className="pi-placeholder">
                            Verify New Email
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </section>
                <section className="personal-i-section"></section>

                <div className="pi-bottom">
                  <div className="piBack-save-btns">
                    <Link to={"/dashboard"} className="back-from-pi">
                      <button>
                        <span>Back to My Account</span>
                      </button>
                    </Link>
                    <div className="save-pi">
                      <button
                        className="savePersona-info"
                        onClick={() => {
                          _submitHandler();
                        }}
                      >
                        <span>Save</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
updateUser.propTypes = {
  updateUser: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});
export default connect(mapStateToProps, { updateUser })(EditAccount);
